import { usageId } from '../../../../constants/usageid.js';
import { ReportConfigurationSchemaIds, ReportConfigurationTags } from '../../schemas/configuration.const.js';
export const dictionary = {
    schema: {
        [usageId(ReportConfigurationSchemaIds.REPORT_CONFIGURATION, ReportConfigurationTags.DEFAULT)]: {
            title: 'Report\'s time range',
            description: '',
            abbr: '',
            cti: '',
            properties: {
                range: {
                    title: 'Report start:Report end',
                    description: 'Start date of the report:End date of the report (exclusive)',
                    abbr: 'Start:End',
                }
            }
        },
        [usageId(ReportConfigurationSchemaIds.REPORT_CONFIGURATION, ReportConfigurationTags.EXPORT)]: {
            title: 'Export\'s time range',
            description: '',
            abbr: '',
            cti: '',
            properties: {
                range: {
                    title: 'Export start:Export end',
                    description: 'Start date of the export:End date of the export (exclusive)',
                    abbr: 'Start:End',
                }
            }
        }
    }
};
